"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.discountDeliveryFeeFrance = exports.discountDeliveryFeeEurope = void 0;
var discountDeliveryFeeFrance = exports.discountDeliveryFeeFrance = {
  name: 'Frais livraison offert avec Mondial Relay',
  type: 'COMMISSION',
  value: 0,
  unit: 'EUROS',
  discountOnItems: [],
  reason: 'ACQUISITION',
  deliveryFee: {
    unit: 'PERCENTAGE',
    value: 100,
    forMondialRelay: true
  }
};
var discountDeliveryFeeEurope = exports.discountDeliveryFeeEurope = {
  name: '-50% on Delivery Fees with Mondial Relay',
  type: 'COMMISSION',
  value: 0,
  unit: 'EUROS',
  discountOnItems: [],
  reason: 'ACQUISITION',
  deliveryFee: {
    unit: 'PERCENTAGE',
    value: 50,
    forMondialRelay: true
  }
};